/* eslint-disable */
import { TimelineMax, TweenMax, TweenLite, TimelineLite } from 'gsap';

export {
    TimelineMax,
    TimelineLite,
    TweenMax,
    TweenLite
};
